import styled from "styled-components"

const InnerContainer = styled.div`
  max-width: 635px;
  width: inherit;
`

export default InnerContainer



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/InnerContainer.js